/**
 * VYRO scroll-reveal — single-pass IntersectionObserver.
 * Mark up: data-vyro-reveal[="up|fade|scale"] on the element.
 * Stagger children by adding data-vyro-stagger on the container.
 * Respects prefers-reduced-motion.
 */
(() => {
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (REDUCED) {
    document.documentElement.classList.add('vyro-reveal-disabled');
    return;
  }

  const STAGGER_STEP_MS = 80;
  const ROOT_MARGIN = '0px 0px -8% 0px';
  const THRESHOLD = 0.12;

  const reveal = (el) => {
    el.classList.add('vyro-revealed');
  };

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const stagger = el.closest('[data-vyro-stagger]');
        if (stagger && stagger === el.parentElement) {
          const siblings = Array.from(stagger.children).filter((c) =>
            c.hasAttribute('data-vyro-reveal')
          );
          const idx = siblings.indexOf(el);
          el.style.setProperty('--vyro-reveal-delay', `${idx * STAGGER_STEP_MS}ms`);
        }
        reveal(el);
        obs.unobserve(el);
      });
    },
    { rootMargin: ROOT_MARGIN, threshold: THRESHOLD }
  );

  const observeAll = (root = document) => {
    root.querySelectorAll('[data-vyro-reveal]:not(.vyro-revealed)').forEach((el) => {
      observer.observe(el);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => observeAll());
  } else {
    observeAll();
  }

  // Re-scan when Shopify section editor rerenders
  document.addEventListener('shopify:section:load', (e) => observeAll(e.target));
})();
